module.exports = __webpack_public_path__ + "img/Smart_Tales_Logo.0f4eda85.png";